import React from "react";
import { SovosButton } from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { handleAssociationEntityToPackage } from "../../actions/UserActions/HandleUserActions";
import { usePackageAssociation } from "./PackageAssociationContext";

const PackageAssociationSaveButton = () => {
    const { i18n, params, pushDialog, pushNotification, saveWorkerAssociationPackage } =
        useGlobalValue();
    const { checkList, hasChanges, resetCheckList, setCheckList } = usePackageAssociation();

    const handleSave = () => {
        handleAssociationEntityToPackage({
            pushDialog,
            i18n,
            checkList,
            params,
            saveWorkerAssociationPackage,
            setCurrentCheckedList: () => resetCheckList(),
            setOriginalCheckedList: () => setCheckList(checkList),
            pushNotification,
        });
    };

    return (
        <SovosButton variant="contained" disabled={!hasChanges} onClick={handleSave}>
            {i18n`save changes`}
        </SovosButton>
    );
};

export default PackageAssociationSaveButton;
